// @flow

import React, { Component } from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import queryString from "query-string";
import { goToAuthPage } from "ducks/user/actions";

import logo from "./logo/logo-added-auth.png"
import button from "./logo/button-added-auth.png"

class LoginAdded extends Component {
  componentDidMount() {
    if (window.location.search) {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if(/android/i.test(userAgent)) {
        const parsed = queryString.parse(window.location.search);
        // eslint-disable-next-line
        (`${parsed.state.split(" ")[1]}` !== `${window.location.origin}${window.location.pathname}`)?document.location.replace(`${parsed.state.split(" ")[1]}?code=${parsed.code}&state=${parsed.state}`):null
      } else {
        this.props.goToAuthPage(window.location.search)
      }
    }
  }

  goToAuthPage = () => {
    this.props.goToAuthPage(window.location.search)
  }

  render() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return (
        /android/i.test(userAgent) ?
          <div style={{textAlign: "center", position: "absolute", justifyContent: "center", width: "100%", display: "flex", height: "100%", alignItems: "center", flexDirection: "column"}}>
            <img src={logo} alt="Hedged Bitcoin Logo" style={{width: "250px", height: "223px"}} />
            <h1 style={{fontSize: "2em", marginTop: "20px"}}>
              <FormattedMessage id="hbc.login.added.auth" defaultMessage="Authorization complete" />
            </h1>
            <p style={{fontSize: "1.5em"}}>
              <a id="link" href={`${window.location.origin}/auth/${window.location.search}`} style={{display: "inline-block", textDecoration: "none", lineHeight: 4.5, textAlign: "center", zIndex: 999, cursor: "pointer", color: "#21ce99"}}>
                <FormattedMessage id="hbc.login.added.continue" defaultMessage="Continue" />
              </a>{" "}
              <FormattedMessage id="hbc.login.added.continue.to" defaultMessage="to Hedged Bitcoin" />
            </p>
            <div onClick={this.goToAuthPage} style={{background: `url(${button}) 0 0 no-repeat scroll transparent`, width: "250px", height: "50px", fontSize: "1.5em", cursor: "pointer", lineHeight: "3.4", paddingLeft: "11%", color: "white", fontWeight: "600", marginTop: "100px"}}>
              <FormattedMessage id="hbc.login.added.continue.button" defaultMessage="CONTINUE" />
            </div>
          </div>
        :
          null
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user
})

export default connect(mapStateToProps, {goToAuthPage})(LoginAdded);



// WEBPACK FOOTER //
// ./src/containers/auth/loginadded/Login.js